<template>
  <v-row
    dense
    v-if="engagement"
    @click="$emit('click')"
    :class="click ? 'cursor-pointer' : ''"
  >
    <v-col class="font-weight-medium" cols="auto">
      {{ title }}
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto" class="font-weight-medium">
      {{ engagement.completion | no_decimal }}%
    </v-col>
    <v-col cols="12">
      <v-progress-linear
        class="rounded-sm"
        :value="engagement.completion"
        background-color="background"
        :color="
          $coreScores.getColor($coreScores.reverseFormat(engagement.completion))
        "
        height="8"
      ></v-progress-linear>
    </v-col>
    <v-col cols="12" class="caption">
      {{ engagement.finished }} / {{ engagement.sent }} completed
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "EngagementText",
  props: {
    engagement: { type: Object },
    title: { type: String },
    click: { type: Boolean, default: false }
  }
};
</script>
